import React, { useState } from 'react';

import MARKETBASE_THEME from '@dashboard/contexts/ThemeManager/theme';
import { Box, Link, Stack, Tab, Tabs, Typography } from '@mui/material';

import useCurrentWorkflowId from '../../useCurrentWorkflowId';

import CodeExample from './CodeExample';

type Props = {
  customKeyValue?: string | null;
  customKeyDropdown: JsxNode;
};

type TCurrentTab = 'CURL' | 'NODE';

export default function ApiExample({ customKeyValue, customKeyDropdown }: Props) {
  const workflowId = useCurrentWorkflowId();
  const [currentTab, setCurrentTab] = useState<TCurrentTab>('CURL');

  const getCaptionText = () => {
    switch (currentTab) {
      case 'CURL':
        return 'Modify this cURL example as needed and then paste it into your terminal to trigger the workflow.';
      case 'NODE':
        return 'Modify this example as needed and then run it in your Node.js codebase to trigger the workflow.';
    }
  };

  return (
    <Box>
      <Tabs
        value={currentTab}
        onChange={(_, value) => setCurrentTab(value)}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="cURL" value="CURL" sx={{ ...MARKETBASE_THEME.typography.body1, fontWeight: 'fontWeightMedium' }} />
        <Tab label="Node.js" value="NODE" />
      </Tabs>
      <Stack mt={2} spacing={1.5}>
        <Typography variant="body2" color="text.secondary">
          {getCaptionText()}{' '}
        </Typography>
        <Box sx={{ border: '1px solid', borderColor: 'divider' }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: 0.5, borderBottom: '1px solid', borderColor: 'divider' }}
          >
            {customKeyDropdown}
          </Stack>

          <CodeExample type={currentTab} workflowId={workflowId} workflowKey={customKeyValue} />
        </Box>

        <Typography variant="body2" color="text.secondary" paragraph>
          <Link
            fontWeight="fontWeightMedium"
            underline="hover"
            color="inherit"
            target="_blank"
            href="https://www.usewaypoint.com/docs/triggering-workflows"
          >
            Learn more in our docs
          </Link>
        </Typography>
      </Stack>
    </Box>
  );
}
